import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import type { BlockEditProps } from '@plone/types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import config from '@plone/registry';

import Slider from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/Slider/Slider';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/styles.module.css';
import type { ProductsSliderData } from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/schema';

type ProductsSliderEditProps = Omit<BlockEditProps, 'data'> & {
  data: ProductsSliderData;
};

const Edit = (props: ProductsSliderEditProps) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  const { selected, data, blocksConfig, onChangeBlock, block, className } =
    props;
  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });
  return (
    <>
      <section className={cx('block-products-slider', styles.block)}>
        {!data?.styles?.fullwidth ? (
          <Container
            className={cx(
              'block-products-slider-container',
              styles.editorContainer,
            )}
          >
            {data.title && (
              <div className={styles.blockTitle}>
                <h2>{data.title}</h2>
              </div>
            )}
            {data.description && (
              <div className={styles.blockDescription}>
                <p>{data.description}</p>
              </div>
            )}
            {data.slides?.length > 0 ? (
              <Slider slides={data.slides} />
            ) : (
              <div className={styles.noSlidesMessageContainer}>
                {intl.formatMessage(messages.no_slides)}
              </div>
            )}
          </Container>
        ) : (
          <div className={styles.editorContainer}>
            {data.title && (
              <div className={styles.blockTitle}>
                <h2>{data.title}</h2>
              </div>
            )}
            {data.description && (
              <div className={styles.blockDescription}>
                <p>{data.description}</p>
              </div>
            )}
            {data.slides?.length > 0 ? (
              <Slider slides={data.slides} isEditMode={true} />
            ) : (
              <div className={styles.noSlidesMessageContainer}>
                {intl.formatMessage(messages.no_slides)}
              </div>
            )}
          </div>
        )}
      </section>
      {/* @ts-expect-error TODO fix */}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          {...props}
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;

const messages = defineMessages({
  no_slides: {
    id: 'no_slides',
    defaultMessage: 'No slides to show. Add slides from the sidebar',
  },
});
